import AppTab, { AppTabProps } from "../Tab/AppTab";
import AppTabs, { AppTabsProps } from "../Tab/AppTabs";

export interface DataTabularTabsProps {
  tabsProps: AppTabsProps;
  tabPropsList: AppTabProps[];
}

export function DataTabularTabs({ tabsProps, tabPropsList }: DataTabularTabsProps) {
  return (
    <AppTabs variant='scrollable' scrollButtons='auto' allowScrollButtonsMobile {...tabsProps}>
      {tabPropsList.map((tabProps, index) => (
        <AppTab key={index} {...tabProps} />
      ))}
    </AppTabs>
  );
}
